import React from 'react'
import { Box } from '@mui/material'
import { Embroidery } from 'src/types'
import { genEmbroideryCells } from 'src/features/generatePdf/helper/embroidery'
import { useLocale } from 'src/locales/useLocale'
import { NoEmbroidery } from 'src/features/simulationConfirm/components/NoEmbroidery'
import { ItemCell } from 'src/features/simulationConfirm/components/ItemCell'
import { muiGrey } from 'src/style/muiTheme'
import { cellColor } from '../normal/simulationContents'

type Props = {
  embroideries: Embroidery[]
  previousIndex: number
}

export const Embroideries: React.FC<Props> = ({ embroideries, previousIndex }) => {
  const { t } = useLocale()
  return (
    <>
      {embroideries
        ?.filter((e) => e.content.trim().length > 0)
        .map((embroidery, index) => {
          const embroideryCells = genEmbroideryCells(embroidery, t)
          return (
            <React.Fragment key={`${index}`}>
              {embroidery.content.trim().length > 0 ? (
                <Box mb={2}>
                  <Box fontWeight="bold" fontSize="16px" color={muiGrey}>
                    {t.EMBROIDERY_ITEMS}
                    {index + 1}
                  </Box>
                  {embroideryCells.map((cell, i) => (
                    <ItemCell key={cell.head} itemIndex={i + previousIndex + index * 6} cell={cell} color={cellColor(cell?.value)} />
                  ))}
                </Box>
              ) : (
                <NoEmbroidery />
              )}
            </React.Fragment>
          )
        })}
    </>
  )
}
